import {BASE_SERVICE_URL} from '../lib/constants'

export default function (uid, sheetIndex, eventType, keys, fileName) {

    return fetch(BASE_SERVICE_URL + `/${uid}/${sheetIndex}/import`, {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            eventType,
            keys,
            username: window.Live.authorization.user.username,
            fileName
        })
    }).then(response => {
        if (response.ok) {
            return new Promise((resolve, reject) => resolve(response))
        } else {
            const error = new Error(response.statusText)
            error.response = response
            throw error
        }
    })
}

export function importRDO(uid, sheetIndex, eventType, keys, fileName) {
    return fetch(`/services/live-spreadsheets/spreadsheets/${uid}/${sheetIndex}/importRDO`, {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            eventType,
            keys,
            username: window.Live.authorization.user.username,
            fileName
        })
    }).then(response => {
        if (response.ok) {
            return new Promise((resolve, reject) => resolve(response))
        } else {
            const error = new Error(response.statusText)
            error.response = response
            throw error
        }
    })
}
